<template>
  <div class="control-section">
    <div  class="h100vh-140">
      <ejs-grid ref='grid' :dataSource="data" height='calc(100% - 0px)' :rowDeselected='getChooseCount' :rowSelected='getChooseCount' :allowReordering='true' :allowResizing='true'>
        <e-columns>
          <e-column type='checkbox' headerText='testId' width='66' textAlign='Center' minWidth='10px'></e-column>
          <e-column field='profileId' :headerText='$t("Usersub.profileId")'  clipMode='EllipsisWithTooltip' textAlign='Center' minWidth='10px'></e-column>
          <e-column field='profileName' :headerText='$t("Usersub.profileName")'  clipMode='EllipsisWithTooltip' textAlign='Center' minWidth='10px'></e-column>
          <e-column field='plmnProfileIds' :headerText='$t("Usersub.plmnInfos")'  clipMode='EllipsisWithTooltip' textAlign='Center' minWidth='10px'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref='pager' @click='qryProfiles()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
    </div>
    <CustomDialog ref='addProfilePage' :element='dialog.element.eleAddProfile' :styles='dialog.styles' :messages='dialog.messages.addProfile'>
      <template v-slot:dialog-content>
        <AddProfileForm ref="addProfile" ></AddProfileForm>
      </template>
    </CustomDialog>
    <CustomDialog ref='modProfilePage' :element='dialog.element.eleModProfile' :styles='dialog.styles' :messages='dialog.messages.modProfile'>
      <template v-slot:dialog-content>
        <ModProfileForm ref="modProfile" ></ModProfileForm>
      </template>
    </CustomDialog>
    <Notification ref='notification' :position='position' timeOut='2000' ></Notification>
    <DialogConfirm ref='dialogConfirm' :title='$t("Common.confirm")' :content='$t("Profile.delConfirm")' :onOk='onClickDelOk' ></DialogConfirm>
    <CustomDialog ref='dialogListPage' :element='dialog.element.eleDialogList' :styles='dialog.stylesDialogList'>
      <template v-slot:dialog-content>
        <DialogList ref='dialogList'></DialogList>
      </template>
    </CustomDialog>
  </div>
</template>

<script>

import { Reorder, Resize } from '@syncfusion/ej2-vue-grids';
import CustomDialog from '../../../common/CustomDialog';
import Notification from "../../util/tipDialog/Notification";
import DialogConfirm from "../../util/tipDialog/DialogConfirm";
import DialogList from "../../util/tipDialog/DialogList";
import AddProfileForm from './dialog/AddProfileForm';
import ModProfileForm from './dialog/ModProfileForm';
import ajaxUrl from "../../data/ajaxUrl";
import { EventBus } from '../../../../plugins/eventBus';

export default {
  name: 'ProfileTable',
  components: {
    CustomDialog,
    Notification,
    DialogConfirm,
    AddProfileForm,
    ModProfileForm,
    DialogList,
  },
  data() {
    return {
      data: {},
      page: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
        pageCount: 0,
      },
      ne: {
        neid: '',
        netype: '',
        neversion: '',
      },
      chooseCount: 0,
      dialog: {
        styles: {
          width: '810px',
          height: '760px',
          visible: false,
          model: true,
        },
        stylesGroupList: {
          width: '30%',
          height: '80%',
          visible: false,
          model: true,
        },
        stylesSearch: {
          width: '30%',
          height: '30%',
          visible: false,
          model: true,
        },
        stylesDialogList: {
          width: "30%",
          height: "50%",
          visible: false,
          model: true
        },
        element: {
          eleAddProfile: {
            target: this.$refs.addProfile,
            refName: 'eleAddProfile',
            buttonGroup: [
              { click: this.saveAddProfile, buttonModel: { content: this.$t("Profile.confirm"), isPrimary: true } },
              { click: this.closeAddProfilePage, buttonModel: { content: this.$t("Profile.cancel") } }
            ],
            title: this.$t("Usersub.addProfile"),
            isClose: true,
          },
          eleModProfile: {
            target: this.$refs.modProfile,
            refName: 'eleModProfile',
            buttonGroup: [
              { click: this.saveModProfile, buttonModel: { content: this.$t("Profile.confirm"), isPrimary: true } },
              { click: this.closeModProfilePage, buttonModel: { content: this.$t("Profile.cancel") } }
            ],
            title: this.$t("Usersub.modProfile"),
            isClose: true,
          },
          eleDialogList: {
            target: this.$refs.dialogList,
            refName: 'dialogList',
            buttonGroup: [
              {
                click: this.closeDialogListPage,
                buttonModel: { content: this.$t("Profile.confirm"), }
              }
            ],
            title: this.$t("Profile.logger"),
            isClose: true,
          },
        },
        messages: {
          addProfile: {
            title: this.$t("Usersub.addProfile"),
          },
          modProfile: {
            title: this.$t("Usersub.modProfile"),
          },
        },
      },
      position: { X: 'Center', Y: 'Top' },
      descCommonError: {
        0: this.$t("DNN.commonError0"),
        1: this.$t("DNN.commonError1"),
        2: this.$t("DNN.commonError2"),
        3: this.$t("DNN.commonError3"),
        4: this.$t("DNN.commonError4"),
        5: this.$t("DNN.commonError5"),
        6: this.$t("DNN.commonError6"),
        7: this.$t("DNN.commonError7"),
        8: this.$t("DNN.commonError8"),
        9: this.$t("DNN.commonError9"),
        10: this.$t("DNN.commonError10"),
        11: this.$t("DNN.commonError11"),
        12: this.$t("DNN.commonError12"),
        13: this.$t("DNN.commonError13"),
        14: this.$t("DNN.commonError14"),
        15: this.$t("DNN.commonError15"),
      },
    };
  },
  provide: {
      grid: [ Reorder, Resize ],
  },
  methods: {
    getGridData(ne) {
      this.ne.neid = ne.data.id;
      this.ne.netype = ne.data.neType;
      this.ne.neversion = ne.data.neVersion;
      this.qryProfiles();
    },
    isChooseNe() {
      if (this.ne.neid === '') {
        EventBus.$emit('toast', {type: 'warning', content: this.$t("LteUser.pleaseSelectNE")});
        return false;
      }
      return true;
    },
    getCheckedDatas(selectOnly = false) {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t("PDN.pleaseSelectDatas")});
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t("PDN.pleaseSelectOneData")});
        return false;
      }
      return selectedRecords;
    },
    getCheckedKeys(selectOnly = false) {
      // x-> false: 不支持多选   true: 支持多选
      const profileId = [];
      const checkedData = this.getCheckedDatas(selectOnly);
      for (let i = 0; i < checkedData.length; i++) {
        profileId.push(checkedData[i].profileId);
      }
      return profileId.length === 0 ? false : profileId;
    },
    getChooseCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.chooseCount = selectedRecords.length;
    },
    responseIsFailed(response) {
      if (!response) {
        console.log("response error");
        return true;
      }
      if (!response.data) {
        console.log("response.data error");
        return true;
      }
      if (!response.data.resultVal) {
        console.log("response.data.resultVal error");
        return true;
      }
       if (0!==response.data.resultVal.result) {
        EventBus.$emit('toast', {type: 'warning', 
        content: response.data.errorString
        });
        return true;
      }
      return false;
    },
    openAddProfilePage() {
      if (this.isChooseNe() === false) {
        return;
      }
      this.$refs.addProfile.getJson(this.ne, (response) => {
        if(response.data.errorCode !== "0") {
          EventBus.$emit('toast', {type: 'warning', content: response.data.errorString});
          return;
        }
        this.$refs.addProfilePage.show();
      });
    },
    closeAddProfilePage() {
      this.$refs.addProfilePage.clear();
      this.$refs.addProfilePage.close();
    },
    saveAddProfile() {
      this.$refs.addProfile.saveProfile(this.ne, (response) => {
        if (this.responseIsFailed(response)) {
          return;
        }
        this.closeAddProfilePage();
        EventBus.$emit('toast', {type: 'success', content: this.$t("Usersub.addProfileSuccess")});
        this.qryProfiles();
      });
    },
    openModProfilePage() {
      if (this.isChooseNe() === false) {
        return;
      }
      const checkedDatas = this.getCheckedDatas();
      if (checkedDatas) {
         const record = checkedDatas.map((item) => {
          return {
            ...item,
          }
        });
        this.$refs.modProfile.getJson(this.ne, record, (response) => {
          if(response.data.errorCode !== "0") {
            EventBus.$emit('toast', {type: 'warning', content: response.data.errorString });
            return;
          }
          this.$refs.modProfilePage.show();
        });
      }
    },
    closeModProfilePage() {
      this.$refs.modProfilePage.clear();
      this.$refs.modProfilePage.close();
    },
    saveModProfile() {
      this.$refs.modProfile.saveProfile(this.ne, (response) => {
        if (this.responseIsFailed(response)) {
          return;
        }
        this.closeModProfilePage();
        EventBus.$emit('toast', {type: 'success', content: this.$t("Usersub.modProfileSuccess")});
        this.qryProfiles();
      });
    },
    delProfiles() {
      if (this.getCheckedKeys(true)) {
        this.$refs.dialogConfirm.show();
      }
    },
    onClickDelOk() {
      const delKeys = this.getCheckedKeys(true);
      const params = {
        vo: {
          profileIds: delKeys,
        },
        info: {
          msgid: "28690",
          neid: this.ne.neid,
        }
      };

      this.$axios.post(ajaxUrl.delCommonD, params).then(response => {
        if (!response) {
          console.log("delPdnProfile response error");
          return;
        }
        if (!response.data) {
          console.log("delPdnProfile response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("delPdnProfile response.data.resultVal null error");
          return;
        }
       const resultVal = response.data.resultVal.resultCode;
       const resultCodeStr = response.data.resultVal.resultCodeStr;
        const operList = [];
        for (let i = 0; i < delKeys.length; i++) {
          operList.push({
            operObj: delKeys[i],
            operResult: resultCodeStr[i],
            operCode:resultVal[i]
          });
        }
        this.$refs.dialogList.addUDMOperetionResultList(operList);
        this.$refs.dialogList.setTotalCount(delKeys.length);
        this.$refs.dialogListPage.show();
        // EventBus.$emit('toast', {type: 'success', content: this.$t("DNN.delProfileSuccess")});
        this.qryProfiles();
      });
    },
    closeDialogListPage() {
      this.$refs.dialogListPage.clear();
      this.$refs.dialogListPage.close();
    },
    qryProfiles(promptSuccess) {
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = {
        vo: {
          flag: 0,
        },
        info: {
          msgid: "28691",
          neid: this.ne.neid,
        },
        page: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
        },
      };

      this.$axios.post(ajaxUrl.qryUsersubProfile, params).then((response) => {
        if (!response) {
          console.log("qryPdnProfile response error");
          return;
        }
        if (!response.data) {
          console.log("qryPdnProfile response.data error");
          return;
        }
        if (response.data.errorCode ===  'subscriber.9005') {
          this.ne.neid = '';
          this.data = [];
          this.page.pageCount = 0;
          this.page.totalCount = 0;
          EventBus.$emit('toast', {type: 'warning', content: this.$t('MCS.neOffLine')});
          return;
        }
        if (!response.data.resultVal) {
          console.log("qryPdnProfile response.data.resultVal error");
          this.data = [];
          this.page.pageCount = 0;
          this.page.totalCount = 0;
          return;
        }
        // 当PDN模板和用户签约模板为空时，查询设备端返回0x01000000错误码，暂时规避掉该错误
        if (response.data.resultVal.result !== 0 && response.data.resultVal.result !== 0x01000000 && response.data.resultVal.result !== 1 ) {
          console.log("qryPdnProfile response.data.resultVal.result error");
          this.data = [];
          this.page.pageCount = 0;
          this.page.totalCount = 0;         
          return;
        }
        const res = response.data.resultVal;
        if (res) {
          if (res.userSubProfileInfo) {
            const userSubProfileInfo = res.userSubProfileInfo.map(item => {
              // let plmnInfosStr = '';
              // if (item.plmnInfos) {
              //     item.plmnInfos.map((obj) => {
              //       if(obj.profileId) {
              //         plmnInfosStr += obj.profileId +";";
              //       }
              //     })

              // }
              // var plmnList={count:item.plmnInfos.length,list:item.plmnInfos};
              let plmnIdsStr = '';
              if (item.plmnProfileIds) {
                for(let i=0; i<item.plmnProfileIds.length; i++) {
                  if (item.plmnProfileIds[i]) {
                    plmnIdsStr += item.plmnProfileIds[i];
                    if (i !== item.plmnProfileIds.length-1) {
                      plmnIdsStr += ",";
                    }
                  }
                }
              }
              return {
                ...item,
               plmnProfileIds: plmnIdsStr,
                // plmnInfos: plmnList,
                // plmnId:plmnInfosStr,
              }
            });
            this.data = userSubProfileInfo;
          } else {
            this.data = [];
          }
          console.log("res page",res.page)
          this.page.pageCount = res.page;
          this.page.totalCount = res.countRsp;
          this.page.pageCount = Math.ceil(res.countRsp / this.page.pageSize);
        }
        // if (promptSuccess) {
        //     EventBus.$emit('toast', {type: 'success', content: this.$t("Usersub.qryProfileSuccess")});
        // }
      });
    },
  },
};
</script>

<style scoped>

</style>
